import React, { Component } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import Aadhaar from "./Aadhaar.png";
import abha from "./abha.png";
import Mobile from "./mobile.png";
export default class Abharegister extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleSubmitAadhaar = (e) => {
    window.location.href = "/consentcollectionaadhaar";
  };
  handleSubmitABHA = (e) => {
    window.location.href = "/abhaaddresscreation";
  };
  handleSubmitMobile = (e) => {
    window.location.href = "/mobileauthentication";
  };
  render() {
    return (
      <div>
        <Row className="justify-content-evenly align-items-center createAbhaNumber">
          <Col className="text-center card p-3" md={4}>
            <div className="card-body">
              <Image
                src={Aadhaar}
                alt=""
                style={{
                  width: "auto",
                  height: "80px",
                }}
              />
              <p>Create / Download your ABHA Number using</p>
              <Button className="rounded-1" onClick={this.handleSubmitAadhaar}>
                Aadhaar
              </Button>
            </div>
          </Col>
          <Col className="text-center card p-3" md={4}>
            <div className="card-body">
              <Image
                src={Mobile}
                alt=""
                style={{
                  width: "auto",
                  height: "80px",
                }}
              />
              <p>Create / Download your ABHA Number using</p>
              <Button className="rounded-1" onClick={this.handleSubmitMobile}>
                Mobile
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
